import { ToastContext } from 'contexts'
import { useModal } from 'hooks'
import { useContext } from 'react'
import {
	useActivateValidatorAccountService,
	useDeleteAccountService,
	// useValidatorPendingAccounts,
} from 'services/admin/useAdminService'

export const useAdminActions = () => {
	const { setToast } = useContext(ToastContext)
	const { openModal, closeModal } = useModal()

	// const { refetch } = useValidatorPendingAccounts()
	const { activateValidatorAccount, loading: activation_loader } =
		useActivateValidatorAccountService()

	const { deleteAccount, loading: delete_loader } = useDeleteAccountService()

	const activateAccount = async (id: string) => {
		await activateValidatorAccount(id)
		// refetch()

		setToast({
			message: 'Account was successfully verified!',
			type: 'positive',
			open: true,
		})
	}

	const deleteValidatorAccount = async (id: string) => {
		await deleteAccount(id)
		// refetch()

		setToast({
			message: 'Account was successfully Deleted!',
			type: 'positive',
			open: true,
		})
	}

	const handleActivateAccount = (id: string) => {
		openModal({
			name: 'delete-confirmation-modal',
			data: {
				deleteItem: async () => {
					try {
						await activateAccount(id)
					} catch (e) {
						setToast({
							message: 'Activation Failed!',
							type: 'negative',
							open: true,
						})
					}
					closeModal('delete-confirmation-modal')
				},
				label: 'Activate account?',
			},
		})
	}
	const handleDeleteAccount = (id: string) => {
		openModal({
			name: 'delete-confirmation-modal',
			data: {
				deleteItem: async () => {
					try {
						await deleteValidatorAccount(id)
					} catch (e) {
						setToast({
							message: 'Delete Failed!',
							type: 'negative',
							open: true,
						})
					}
					closeModal('delete-confirmation-modal')
				},
				label: 'Delete account?',
			},
		})
	}

	return {
		handleActivateAccount,
		handleDeleteAccount,
		loading: activation_loader || delete_loader,
	}
}
